
export default (store) => ({
  path: 'summary',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Summary = require('./containers/SummaryContainer').default

      /*  Return getComponent   */
      cb(null, Summary)

    /* Webpack named bundle   */
    }, 'Summary')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/routes/Summary/index.js
 **/